import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { merge, Subscription } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class RouterHelperService implements OnDestroy {
    public params = {
        frontid: '',
        qmnum: '',
        manum: '',
        formid: '',
    };

    public currentUrl = '';

    private routerHelperSubscription: Subscription;
    public constructor(
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
    ) {}

    public ngOnDestroy(): void {
        this.routerHelperSubscription?.unsubscribe();
    }

    public subscribeToEvents(): void {
        const logParams$ = this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd),
            switchMap((event: NavigationEnd) => {
                // The ActivatedRoute service only allows access to the params within the routing target component. As
                // consequence, the navigation link component does not have access and we need them for the routing
                // target. To still have access, we use this service and update the params whenever navigation occurred.
                // This works because we are called from AppComponent, which as a parent to every other component has
                // also access to all routes and route params. (https://github.com/angular/angular/issues/11023)
                let active = this.activatedRoute;
                while (active.firstChild) {
                    active = active.firstChild;
                }
                return active.params.pipe(
                    tap((params) => {
                        this.params.frontid = <string>params.frontid;
                        this.params.qmnum = <string>params.qmnum;
                        this.params.manum = <string>params.manum;
                        this.params.formid = <string>params.formid;
                        this.currentUrl = event.url;
                    }),
                );
            }),
        );

        // empty subscription since all logic happens in the side effects of the observables
        this.routerHelperSubscription = merge(logParams$).subscribe();
    }
}
